<mf-grid
  #grid
  actionButtonText="{{ showCreateButton ? 'Nueva orden' : '' }}"
  [apiEndpoint]="apiEndpoint"
  [columns]="columns"
  [hideFilters]="hideFilters"
  [initialFilters]="filters"
  [mustIncludeFields]="mustIncludeFields"
  [menuItems]="menuItems" />
